<template>
  <div>
    GLASubsidiary
  </div>
</template>

<script>
  export default {
    name: 'g-l-a-subsidiary'
  }
</script>

<style lang="scss" scoped>

</style>